@if (deviceInfo$ | async; as deviceInfo) {
  @if (deviceInfo.isMobile) {
    <wl-generic-offer-carousel
      [products]="products"
      [listName]="listName"
      [productTemplate]="productTemplate"
    ></wl-generic-offer-carousel>
  } @else {
    <div class="row justify-content-center">
      @for (product of products; track product; let index = $index) {
        <div
          class="col-6 col-lg-4"
          [class.product__blank-highlight-space]="
            hasReserveHighlightSpace && !product.content.highlight
          "
        >
          <ng-template
            [ngTemplateOutlet]="productTemplate"
            [ngTemplateOutletContext]="{
              $implicit: product,
              context: {
                index: index,
                numberOfProducts: products.length,
                listName: listName,
              },
            }"
          ></ng-template>
        </div>
      }
    </div>
  }
}
